import Service from './Service';

class HelpService extends Service {
    getHelpByName(fieldName, codeName) {
        return this.get('helpByName?', { fieldName, codeName });
    }

    saveItem(helpId, title, body, fieldName, codeName, idModozat) {
        return this.post('saveItem', {
            item: {
                idmodozat: idModozat,
                mezo: fieldName,
                cimsor: title,
                leiras: body,
                codename: codeName,
                idhelp: helpId,
            },
        });
    }
}

export default new HelpService('/api/help/');
